import { motion } from 'framer-motion'
import { FaGraduationCap } from 'react-icons/fa'

const Welcome = () => {
  return (
    <motion.div
      className='text-center mb-5'
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className='display-1 mb-2 text-white'
        animate={{ rotate: [0, 10, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <FaGraduationCap />
      </motion.div>
      <h1 className='display-4 mb-4 text-white'>शिक्षा साथी में आपका स्वागत है</h1>
      <h2 className='display-6 lead text-white fw-bold '>आज हम कुछ नया और मजेदार सीखेंगे।</h2>
    </motion.div>
  )
}
export default Welcome
